var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgencyPromotion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0492 12.25H33.9492L35.8742 6.3C36.2242 5.25 36.0492 4.025 35.3492 3.15C34.6492 2.275 33.5992 1.75 32.5492 1.75H23.4492C22.3992 1.75 21.3492 2.275 20.6492 3.15C19.9492 4.025 19.7742 5.25 20.1242 6.3L22.0492 12.25Z",
    fill: "#5D89EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4997 45.15L33.5997 15.75H22.3997L17.4997 45.15C17.3247 45.675 17.6747 46.2 18.0247 46.725L26.7747 55.475C27.1247 55.825 27.6497 56 27.9997 56C28.3497 56 28.8747 55.825 29.2247 55.475L37.9747 46.725C38.3247 46.375 38.4997 45.85 38.4997 45.15Z",
    fill: "#B3D5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyPromotion);
export default __webpack_public_path__ + "static/media/agency-promotion.9b84977d.svg";
export { ForwardRef as ReactComponent };